import { cn } from '@/src/util/ui';

export type ModalTypeOptions = {
  modalClasses?: string;
  btnConfirmClasses?: string;
  headerTextClasses?: string;
  closeIconClasses?: string;
};
export type ModalType = {
  [key: string]: ModalTypeOptions;
};

export const MODAL_TYPE: ModalType = {
  //blue border top
  default: {
    btnConfirmClasses: cn('tw-text-white tw-border-cfo-blue-700 tw-bg-cfo-blue-700'),
    modalClasses: cn('tw-border-solid tw-border-t-[5px] tw-border-t-cfo-blue-700'),
  },
  // red border top
  danger: {
    headerTextClasses: cn('tw-text-cfo-red-400'),
    btnConfirmClasses: cn('tw-text-white tw-border-cfo-red-400 tw-bg-cfo-red-400'),
    modalClasses: cn('tw-border-solid tw-border-t-[5px] tw-border-t-cfo-red-400'),
  },
  // plain modal
  inverse: {
    btnConfirmClasses: cn('tw-text-white tw-border-cfo-blue-700 tw-bg-cfo-blue-700'),
    modalClasses: '',
  },
  // header modal blue background-color
  default_bg: {
    headerTextClasses: cn('tw-text-white'),
    closeIconClasses: cn('tw-text-white'),
    btnConfirmClasses: cn('tw-text-white tw-border-cfo-blue-700 tw-bg-cfo-blue-700'),
    modalClasses: cn('tw-bg-cfo-blue-700 tw-text-white'),
  },
  // header modal red background-color
  danger_bg: {
    headerTextClasses: cn('tw-text-white'),
    closeIconClasses: cn('tw-text-white'),
    btnConfirmClasses: cn('tw-text-white tw-border-cfo-red-400 tw-bg-cfo-red-400'),
    modalClasses: cn('tw-bg-cfo-red-400 tw-text-white'),
  },
};

export const ACTION_POSITIONS = {
  between: 'tw-justify-between',
  start: 'tw-justify-start',
  end: 'tw-justify-end',
  reverse_end: 'tw-justify-start tw-flex-row-reverse',
  reverse_start: 'tw-justify-end tw-flex-row-reverse',
};
